module.exports = __webpack_public_path__ + "static/media/louge.0592e8a8.png";